export default "__VITE_ASSET__fabfd145__"